import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AccountPage from "@/pages/AccountPage";
import AuthCallback from "@/pages/AuthCallback";
import CustomerLogin from "@/pages/CustomerLogin";
import AdminLogin from "@/pages/AdminLogin";
import PayPage from "@/pages/PayPage";
import { SiteContentProvider } from "@/lib/siteContent";
import InvoicePage from "@/pages/InvoicePage";
import PlaidOAuth from "@/pages/PlaidOAuth";
import PayLinkPage from "@/pages/PayLinkPage";
import AdminDashboard from "@/pages/AdminDashboard";
import PortfolioPage from "@/pages/PortfolioPage";
import CeramicPage from "@/pages/CeramicPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceBookingPage from "@/pages/ServiceBookingPage";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { AdminAuthProvider } from "@/lib/adminAuth";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<CustomerLogin />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/portfolio" element={<PortfolioPage />} />
      <Route path="/ceramic" element={<CeramicPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/book/:key" element={<ServiceBookingPage />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/plaid-oauth" element={<PlaidOAuth />} />
      <Route path="/p/:linkId" element={<PayLinkPage />} />
      <Route path="/pay/:bookingId" element={<PayPage />} />
      <Route path="/invoice/:invoiceId" element={<InvoicePage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <SiteContentProvider><BrowserRouter>
        <AuthProvider>
          <AdminAuthProvider>
            <AppRouter />
            <Toaster position="top-right" theme="dark" />
          </AdminAuthProvider>
        </AuthProvider>
      </BrowserRouter></SiteContentProvider>
    </div>
  );
}

export default App;
